import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { first } from 'rxjs/operators';

import { Usergroup_Role_Type_Enum } from 'app/graphql/generated/graphql-types';
import { mergeRouteParams } from 'app/helpers';
import { UsergroupService } from 'app/services';

export const usergroupRoleGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router: Router = inject(Router);
    const usergroupService = inject(UsergroupService);

    const params = mergeRouteParams(route);
    if (!params.usergroupHash) {
        router.navigate(['/']);
        return false;
    }

    const canAccess: ReplaySubject<boolean> = new ReplaySubject(1);

    if (
        route.data &&
        route.data['allowedRoles'] &&
        route.data['allowedRoles'].indexOf(Usergroup_Role_Type_Enum.guest) === -1
    ) {
        usergroupService
            .getUsergroup(params.usergroupHash)
            .pipe(first())
            .subscribe({
                next: ({ data }) => {
                    if (
                        route.data &&
                        route.data['allowedRoles'] &&
                        data.usergroup.merole &&
                        route.data['allowedRoles'].indexOf(data.usergroup.merole) !== -1
                    ) {
                        usergroupService.setIsAdminProfile(!!route.data['adminProfile']);
                        canAccess.next(true);
                        return;
                    }

                    router.navigate(['/group', params.usergroupHash]);
                    canAccess.next(false);
                },
                error: () => {
                    router.navigate(['/']);
                    canAccess.next(false);
                },
            });
    } else {
        usergroupService.setIsAdminProfile(false);
        canAccess.next(true);
    }

    return canAccess;
};
